import React from "react";
import "./ourStory.css";

export default function OurStory() {
	return (
		<div className='ourStory'>
			<div className='story'>
				<p id='thePromise'>
					Our promise to you is to always deliver quality, focus on your
					satisfaction, provide thoughtful communication, and to do what we say
					we are going to do.
				</p>

				<p>
					Active Electric Co. was formed in 2019 with a drive for customer
					satisfaction and building relationships through quality workmanship
					and competitive pricing. With over twenty-five years of skilled
					experience, we have a complete understanding of the importance of
					jobsite safety, continuing knowledge of our ever growing trade, and
					honoring our commitments to our clients and our clients’ clients.
				</p>
				<p>
					Our services include Residential, Commercial, and Industrial
					Electrical installations and services. Our wide range of training and
					knowledge allows us to complete many different size projects and
					tasks. We assist you to accomplish your needs through our abilities.
				</p>
				<p>
					Contact us and lets discuss your project… With personal relationships
					with our vendors and a complete understanding of our industry, we will
					be able to provide very competitive pricing that will help us stand
					out against our competitors.
				</p>

				<p id='storyPhone'>
					Call us now at (602) 549-5052 now to schedule a qoute and discuss your
					next project.
				</p>
			</div>
		</div>
	);
}
